import * as http from '@/utils/http.js';

/**
 * 获取文案老师
 *
 * @author Cong Peijun <congpeijun@jiemo.net>
 * @return {Promise}
 */
export function getWriteTeachers() {
  return http._get('/index/api_base/writeTeacher');
}

/**
 * 咨询老师
 * @author Cong Peijun <congpeijun@jiemo.net>
 * @return {Promise}
 */
export function getAdvisoryTeachers() {
  return http._get('/index/api_base/advisoryTeacher');
}

/**
 * 客服老师
 *
 * @author Cong Peijun <congpeijun@jiemo.net>
 * @return {Promise}
 */
export function getCseTeachers() {
  return http._get('/index/api_base/caseTeacher');
}

/**
 * 文书老师
 *
 * @author Cong Peijun <congpeijun@jiemo.net>
 * @return {Promise}
 */
export function getDocumentTeachers() {
  return http._get('/index/api_base/documentTeacher');
}

/**
 * 根据角色获取老师
 *
 * @author Cong Peijun <congpeijun@jiemo.net>
 * @param  {Number} role [description]
 * @return {Promise}      [description]
 */
export function getTeachers(role) {
  return http._get(`/index/api_base/getTeachers/role/${role}`);
}
